module.exports = __webpack_public_path__ + "static/img/signin-lcic-default.42a606ea.svg";